export enum ButtonActionType {
    NavigateTo = 'navigate-to',
    AddVariantToCart = 'add-variant-to-cart',
}

export enum ButtonPositionType {
    BelowText = 'below-text',
    Custom = 'custom',
}

export enum ButtonNavigationType {
    NavigateToProduct = 'navigate-to-product',
    NavigateToCollection = 'navigate-to-collection',
    NavigateToPage = 'navigate-to-page',
    NavigateToWebsite = 'navigate-to-website',
}

export enum HeroLayoutType {
    LeftTextFullMedia = 'left-text-full-media',
    RightTextFullMedia = 'right-text-full-media',
    MiddleTextFullMedia = 'middle-text-full-media',
    CustomTextLocationFullMedia = 'custom-text-location-full-media',
}

export enum RoundedCornerSize {
    None = 'none',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    Full = 'full',
}

export enum MarketingBannerType {
    LeftMediaRightText = 'left-media-right-text',
    LeftTextRightMedia = 'left-text-right-media',
    TopTextBelowMedia = 'top-text-below-media',
    MediaOnly = 'media-only',
    TitledMedia = 'titled-media',
    KeyPointList = 'key-point-list',
    HeroSection = 'hero-section',
}

export enum AddToCartResult {
    SUCCESS,
    OUT_OF_STOCK,
    ERROR,
}

export enum AdjustItemQuantityResult {
    SUCCESS,
    OUT_OF_STOCK,
    ERROR,
}

export enum RemoveItemResult {
    SUCCESS,
    ERROR,
}

export enum CollectionItemType {
    Product = 'Product',
    ProductVariant = 'ProductVariant',
}

export enum ProductCardType {
    Regular = 'regular',
    RegularType2 = 'regular-type2',
    HorizontalType1 = 'horizontal-type',
    LeftAssetSmall = 'left-asset-small',
    RightAssetSmall = 'right-asset-small',
    LeftAssetLarge = 'left-asset-large',
    RightAssetLarge = 'right-asset-large',
    TopAssetSmall = 'top-asset-small',
    TopAssetLarge = 'top-asset-large',
    FullAsset = 'full-asset',
}

export enum ProductCardShape {
    Rectangle = 'rectangle',
    Square = 'square',
}

export enum ProductOptionGroupDisplayType {
    Dropdown = 'dropdown',
    Options = 'options',
    Tiles = 'tiles',
    BigTiles = 'big-tiles',
    OptionsWithPrice  = 'options-with-price',
    RadioListWithPrice = 'radio-list-with-price',
}

export enum SiteStyleType {
    CopyrightNotice = 'copyright-notice',
    Disclaimer = 'disclaimer',
    PDPAssetsArrowType = 'pdp-assets-arrow-type',
    MobileBuyBannerType = 'mobile-buy-banner-type',
}

export enum CarouselArrowType {
    LargeChevron = 'large-chevron',
    Chevron = 'chevron',
    Arrow = 'arrow',
    SmallArrow = 'small-arrow',
    Caret = 'caret',
    None = 'none',
}

export enum MobileBuyBannerType {
    Regular = 'regular',
    HideMSRP = 'hide-msrp',
}

export enum  BackgroundImageDisplayType {
    NameList = "name-list",
    ImageTiles ="image-tiles"
}

export enum TemplateDisplaySize {
    Standard = 'standard',
    Large = 'large',
}

export enum TextAlignment {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
